<div class="content w-100 d-block">
    <div class="col-12 description-cards">
        <div class="row">
            <div *ngFor="let card of descriptionCards" class="col-md-12 col-lg-6 col-sm-12">
                <div *ngIf="currentRoute == card.Url" class="description-cards-container mb-3">
                <div class="description-cards-card h-100">
                    <div class="col-12 d-table description-cards-card-text">
                        <div class="align-middle mt-4">
                            <h4>{{card.Title}}</h4>
                            <p class="mt-3 new-line">{{card.Description}}
                                <a *ngIf="card.Link" href="{{card.Link}}" target="_blank">
                                    {{card.LinkTitle}}</a>
                            </p>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>